// Tracking — Meta Pixel (ID 1746237120037997 已装于 index.html) + dataLayer。
// Base code 在首次加载时已触发一次 PageView；SPA 路由切换由 App.js 调用
// trackPageView。时间戳去重防止 React StrictMode 双执行导致重复触发。
let lastPv = {
  path: typeof window !== "undefined" ? window.location.pathname : null,
  t: Date.now(),
};

export const trackPageView = (path) => {
  if (typeof window === "undefined") return;
  const now = Date.now();
  if (lastPv.path === path && now - lastPv.t < 1500) return;
  lastPv = { path, t: now };
  if (typeof window.fbq === "function") window.fbq("track", "PageView");
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "page_view", page_path: path });
};

export const trackWhatsAppClick = (location, number) => {
  if (typeof window === "undefined") return;
  if (typeof window.fbq === "function") {
    window.fbq("track", "Contact");
    window.fbq("trackCustom", "whatsapp_click", {
      assigned_number: number,
      button_location: location,
      page_path: window.location.pathname,
    });
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "whatsapp_click",
    click_location: location,
    whatsapp_number: number,
  });
};
